export const shapeCreatedMessage = (data) => ({
  type: 'board:shape:created',
  data
})

export const shapeModifiedMessage = (data) => ({
  type: 'board:shape:modified',
  data
})

export const shapeRemovedMessage = (data) => ({
  type: 'board:shape:removed',
  data
})

export const dartCastedMessage = (data) => ({
  type: 'board:dart:casted',
  data
})

export const tapCastedMessage = (data) => ({
  type: 'board:tap:casted',
  data
})
